import { Injectable } from '@angular/core';
import { Database, off, onValue, ref } from '@angular/fire/database';
import { Observable } from 'rxjs';

// import { Chat } from './chat';

@Injectable({
  providedIn: 'root'
})
export class FirebaseServiceService {


  chatsRef: any = null;
  chatsRefId: any = null;

   private dbPath = '/chat';
  private dbGroupPath = '/groupchat';

  private basePath = '/chat';

  constructor(private db: Database) {
    // this.chatsRef = db.list(this.dbPath);
    //this.chatsRefId = db.list(this.dbPath+'/'+);
  }

  // getChatList(id: any) {
  //   return this.db.list(this.dbPath+'/'+id);
  // }

   getChatList(id:any): Observable<any[]> {
    return new Observable(observer => {
      const itemsRef = ref(this.db, `${this.basePath}/${id}`);
      onValue(itemsRef, (snapshot:any) => {
        const result = snapshot.val();
        const arr = result ? Object.values(result) : [];
        observer.next(arr);
      });
    });
  }

  // getGroupChatList(id: any) {
  //   return this.db.list(this.dbGroupPath+'/'+id);
  // }

   getGroupChatList(id:any): Observable<any[]> {
    return new Observable(observer => {
      const itemsRef = ref(this.db, `${this.dbGroupPath}/${id}`);
      onValue(itemsRef, (snapshot:any) => {
        const result = snapshot.val();
        const arr = result ? Object.values(result) : [];
        observer.next(arr);
      });
    });
  }



}
